import React, { useMemo, useState } from "react";
import css from "./FeedbackButtons.module.css";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { ReportReaction, ReportReactionEnum } from "../../common-types/Rating";
import ContentLoader from "../ContentLoader/ContentLoader";

interface FeedbackButtonsProps {
  currentReaction?: ReportReaction;
  isLoading?: boolean;
  onSelect: (reaction: ReportReactionEnum) => void;
}

const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  currentReaction,
  isLoading,
  onSelect,
}) => {
  const [selectedReaction, setSelectedReaction] = useState<ReportReaction>();

  const handleRateButtonClicked = (reaction: ReportReactionEnum) => {
    setSelectedReaction(reaction);
    onSelect(reaction);
  };

  const isLiked = useMemo(() => currentReaction === "like", [currentReaction]);
  const isDisliked = useMemo(
    () => currentReaction === "dislike",
    [currentReaction],
  );

  return (
    <Box className={css["container"]}>
      {isLoading ? (
        <>
          <ContentLoader type="rounded-icon" />
          <ContentLoader type="rounded-icon" />
        </>
      ) : (
        <>
          <IconButton
            disableFocusRipple
            disableRipple
            size="small"
            aria-label="like"
            onClick={() => handleRateButtonClicked(ReportReactionEnum.Like)}
            className={`${css["rating-btn"]} ${isLiked ? css["rating-btn--liked"] : ""}`}
            disableTouchRipple
          >
            <ThumbUpIcon className={css["thumbs-icon"]} />
            {isLoading && selectedReaction === ReportReactionEnum.Like && (
              <CircularProgress size={18} className={css["circular-icon"]} />
            )}
          </IconButton>
          <IconButton
            disableFocusRipple
            disableRipple
            size="small"
            aria-label="dislike"
            onClick={() => handleRateButtonClicked(ReportReactionEnum.Dislike)}
            className={`${css["rating-btn"]} ${isDisliked ? css["rating-btn--disliked"] : ""}`}
          >
            <ThumbDownIcon className={css["thumbs-icon"]} />
            {isLoading && selectedReaction === ReportReactionEnum.Dislike && (
              <CircularProgress size={18} className={css["circular-icon"]} />
            )}
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default FeedbackButtons;
